<template>
  <div class="section credit-info-form" style="height: auto">
    <div style="display:flex;">
      <div>
        <span class="title">{{ $t('CargoMsg.Cargo_CurrentCredit') }}</span>
        <div class="box-content">
          <div class="inner-row">
            <el-form :disabled="readonly || creditDisable || normalRuleContactExist" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item :label="$t('Partners.dateType')" class="margin-Right50">
                <el-select v-model="currentOnlyCreditInfo.remarks" no="remarks">
                  <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_settlementMethod')">
                <div style="display: flex">
                  <el-select v-model="creditDateTypeObj.val1" no="val1">
                    <el-option :label="$t('Partners.monthlySettlement')" :value="-1" />
                    <el-option :label="$t('CargoMsg.Cargo_SettleByWeekly')" :value="-2" />
                    <el-option :label="$t('CargoMsg.Cargo_FixedDateMonthly')" value="n" />
                    <el-option :label="$t('Partners.space5')" :value="-3" />
                    <el-option :label="$t('Partners.dailySettlement')" :value="-4" />
                  </el-select>
                  <el-input-number
                    v-show="creditDateTypeObj.val1==='n'"
                    no="val2"
                    :value="creditDateTypeObj.val2||undefined"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    @input="val=>{creditDateTypeObj.val2=val}"
                  />
                  <el-checkbox
                    v-if="!isZy"
                    v-model="form.blacklist"
                    no="blacklist"
                    :disabled="oujianEditLimit"
                    style="margin-left: 10px"
                    @change="handleBlacklistChange"
                  >{{ $t('Partners.blacklist') }}</el-checkbox>
                </div>
              </el-form-item>
              <br>
              <el-form-item :label="$t('Partners.accountPeriod')" class="margin-Right50">
                <div style="display: flex">
                  <el-input-number
                    v-model="currentOnlyCreditInfo.creditDateLimited"
                    no="creditDateLimited"
                    :min="0"
                    :precision="0"
                    controls-position="right"
                    style="width: 300px"
                  />
                  <el-select v-model="currentOnlyCreditInfo.termUnit" no="termUnit" style="width: 200px;margin-left: 5px">
                    <el-option :label="$t('Partners.day')" :value="0" />
                    <el-option :label="$t('Partners.week')" :value="1" />
                    <el-option :label="$t('Partners.month')" :value="2" />
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Partners.limit')">
                <div style="display: flex">
                  <el-input-number
                    v-model="currentOnlyCreditInfo.credit"
                    no="credit"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 300px"
                  />
                  <el-select v-model="currentOnlyCreditInfo.currency" no="currency" style="margin-left:5px;width: 200px" @change="currencyChanged">
                    <el-option
                      v-for="(item,index) in currencySet"
                      :key="index"
                      :label="item.code"
                      :value="item.code"
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="inner-row">
            <el-form :disabled="readonly" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item :label="$t('Payment.settlementType')" style="width: auto" class="margin-Right50">
                <el-radio-group no="settlementType" :disabled="true" :value="settlementType">
                  <el-radio no="byTicket" :label="true">{{ $t('Message.ByTicket') }}</el-radio>
                  <el-radio no="settlementNotByBill" :label="false">{{ $t('Partners.settlementNotByBill') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_EtdDays')">
                <div style="width: auto">
                  <el-input-number
                    v-model="currentOnlyCreditInfo.etdDays"
                    no="etdDays"
                    :min="0"
                    :max="999"
                    :precision="0"
                    controls-position="right"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="inner-row">
            <el-form :disabled="readonly" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item :label="$t('CargoMsg.Cargo_RemainingTemporaryReleaseQuantity')" style="width: auto" class="margin-Right50">
                <div style="width: auto">
                  <el-input v-model="form.tempNumberAllocation" :disabled="true" />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <hr style="margin: 8px 1px;">
          <div class="inner-row">
            <el-form :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item class="margin-Right50">
                <span slot="label" class="title">{{ $t('CargoMsg.Cargo_ContractCredit') }}</span>
                <el-select class="form-item-350" :value="currentContract.uuid" no="contractRuleUuid" @change="contractChange">
                  <el-option
                    v-for="(item,index) in contractList"
                    :key="index"
                    :label="item.ruleName + (item.contractNo ? ('【' + item.contractNo + '】') : '')"
                    :value="item.uuid"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="inner-row">
            <el-form disabled :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item :label="$t('Partners.dateType')" class="margin-Right50">
                <el-select v-model="contractCreditInfo.remarks" no="contractRemarks">
                  <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_settlementMethod')">
                <div style="display: flex">
                  <el-select v-model="contractCreditDateTypeObj.val1" no="contractVal1">
                    <el-option :label="$t('Partners.monthlySettlement')" :value="-1" />
                    <el-option :label="$t('CargoMsg.Cargo_SettleByWeekly')" :value="-2" />
                    <el-option :label="$t('CargoMsg.Cargo_FixedDateMonthly')" value="n" />
                    <el-option :label="$t('Partners.space5')" :value="-3" />
                    <el-option :label="$t('Partners.dailySettlement')" :value="-4" />
                  </el-select>
                  <el-input-number
                    v-show="contractCreditDateTypeObj.val1==='n'"
                    no="contractVal2"
                    :value="contractCreditDateTypeObj.val2||undefined"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    @input="val=>{contractCreditDateTypeObj.val2=val}"
                  />
                  <el-checkbox
                    v-if="!isZy"
                    v-model="form.blacklist"
                    no="contractBlacklist"
                    style="margin-left: 10px"
                    @change="handleBlacklistChange"
                  >{{ $t('Partners.blacklist') }}</el-checkbox>
                </div>
              </el-form-item>
              <br>
              <el-form-item :label="$t('Partners.accountPeriod')" class="margin-Right50">
                <div style="display: flex">
                  <el-input-number
                    v-model="contractCreditInfo.creditDateLimited"
                    no="contractCreditDateLimited"
                    :min="0"
                    :precision="0"
                    controls-position="right"
                    style="width: 300px"
                  />
                  <el-select v-model="contractCreditInfo.termUnit" no="contractTermUnit" style="width: 200px;margin-left: 5px">
                    <el-option :label="$t('Partners.day')" :value="0" />
                    <el-option :label="$t('Partners.week')" :value="1" />
                    <el-option :label="$t('Partners.month')" :value="2" />
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Partners.limit')">
                <div style="display: flex">
                  <el-input-number
                    v-model="contractCreditInfo.credit"
                    no="contractCredit"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 300px"
                  />
                  <el-select v-model="contractCreditInfo.currency" no="contractCurrency" style="margin-left:5px;width: 200px" @change="currencyChanged">
                    <el-option
                      v-for="(item,index) in currencySet"
                      :key="index"
                      :label="item.code"
                      :value="item.code"
                    />
                  </el-select>
                </div>
              </el-form-item>
              <br>
              <el-form-item v-show="showActualCreditGracePeriodDays" :label="$t('Payment.paymentPeriod')" class="margin-Right50">
                <div style="display: flex">
                  <el-input-number
                    v-model="contractCreditInfo.paymentTerm"
                    no="paymentTerm"
                    :min="0"
                    :precision="0"
                    controls-position="right"
                    style="width: 300px"
                  />
                  <el-select v-model="contractCreditInfo.paymentTermUnit" no="paymentTermUnit" style="width: 200px;margin-left: 5px">
                    <el-option :label="$t('Partners.day')" :value="0" />
                    <el-option :label="$t('Partners.week')" :value="1" />
                    <el-option :label="$t('Partners.month')" :value="2" />
                  </el-select>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="inner-row">
            <el-form disabled :inline="true" :label-width="isZh?'80px':'120px'" label-position="left">
              <el-form-item :label="$t('Payment.settlementType')">
                <el-radio-group no="contractSettlementType" :disabled="true" :value="contractSettlementType">
                  <el-radio no="contractByTicket" :label="true">{{ $t('Message.ByTicket') }}</el-radio>
                  <el-radio no="contractSettlementNotByBill" :label="false">{{ $t('Partners.settlementNotByBill') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%;margin-bottom: 8px">
            <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TempCredit')" name="otherDocuments" style="width:100%;height: 100%">
              <div class="app-main-inner-row row-grid" style="min-height:300px;">
                <cargo-ag-grid
                  :column-defs="tempCreditInfo.columnDefs"
                  :grid-options="tempCreditInfo.gridOptions"
                  :row-data="tempCreditInfo.rowData"
                  :show-side-bar="false"
                  style="height:100%;min-height: 220px;"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
          <hr style="margin: 8px 1px;">
          <div class="inner-row">
            <el-form :disabled="readonly" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left" class="form-item-350">
              <el-form-item :label="$t('Payment.isReceivable')">
                <el-checkbox-group v-model="checkedList" no="receivableDeposit" @change="changeReceivableDeposit">
                  <el-checkbox no="receipt" :label="true" :checked="form.receivableDeposit">{{ $t('Payment.receipt') }}</el-checkbox>
                  <el-checkbox no="payment" :label="false" :checked="!form.receivableDeposit">{{ $t('Payment.payment') }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <br>
              <el-form-item :label="$t('Partners.depositAmount')" class="margin-Right50">
                <el-input-number
                  v-model="form.depositAmount"
                  no="depositAmount"
                  :min="0"
                  :max="9999999"
                  controls-position="right"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('Payment.payReceiveDate')">
                <el-date-picker v-model="form.depositDate" no="depositDate" type="date" value-format="yyyy-MM-dd" />
              </el-form-item>
              <br>
              <el-form-item :label="$t('WriteOff.revenueAndExpenditureMethod')" class="margin-Right50">
                <el-select v-model="form.depositType" no="depositType">
                  <el-option :label="$t('SeaExport.Cash')" :value="0" />
                  <el-option :label="$t('SeaExport.Check')" :value="1" />
                  <el-option :label="$t('SeaExport.Transfer')" :value="2" />
                  <el-option :label="$t('Partners.space8')" :value="3" />
                  <el-option :label="$t('Partners.space9')" :value="4" />
                  <el-option :label="$t('Partners.space10')" :value="5" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Partners.depositCurrency')">
                <!--                <el-select v-model="form.depositCurrency" no="depositCurrency">-->
                <!--                  <el-option label="RMB" value="RMB" />-->
                <!--                  <el-option label="USD" value="USD" />-->
                <!--                  <el-option label="HKD" value="HKD" />-->
                <!--                </el-select>-->
                <cargo-advance-select
                  no="depositCurrency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  filterable
                  :clearable="false"
                  :default-value="form.depositCurrency"
                  @parentCallBack="p=>{form.depositCurrency=p.value;}"
                />
              </el-form-item>
              <br>
              <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                <el-input v-model="form.creditRemarks" no="depositCurrency" type="textarea" :rows="3" />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span v-if="tipVisible" style="color: red">{{ $t('CargoMsg.Cargo_Prompt') }}：{{ $t('Partners.adjustContractInformationInBasicData') }}</span>
      </div>
      <div v-show="readonly || creditDisable || normalRuleContactExist" style="width:300px;margin-left:15px;">
        <cargo-ag-grid
          style="max-height:325px;"
          config-module="2022080401"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryCustomerCompanyIsOver,
  availableReleaseDocRuleGroupList,
  getDefaultCreditInfo
} from '@/api/partner/creditInfo'
import { hasMenu } from '@/utils/commonUtil'
import { loadCompanyRelated } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import {
  DATETYPE_TYPE,
  RULE_ALL_ORDERS
} from '@/class/cargo/model/parameters/ContractConstants'
import lodash from 'lodash'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'CreditInfoForm',
  components: { cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    },
    branchId: {
      type: Number,
      required: true
    },
    oujianEditLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      DATETYPE_TYPE,
      selectTypeNames: TYPE_NAMES,
      isvalidContract: false,
      tipVisible: false,
      row: null,
      initialForm: null,
      lastCurrency: '',
      config: {},
      creditUseMultipleCurrency: false,
      actualCreditGracePeriodDays: 0,
      activeTabName: 'otherDocuments',
      contractCreditInfo: {
        creditDateType: -1,
        remarks: 'ETD',
        creditDateLimited: 0,
        termUnit: 0,
        paymentTerm: 0,
        paymentTermUnit: 0,
        credit: 0,
        currency: 'RMB'
      },
      initialContractCreditInfo: null,
      tempCreditInfo: {
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
            field: 'effectiveDate',
            colId: 'effectiveDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
            field: 'expirationDate',
            colId: 'expirationDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Partners.credit_limit'),
            field: 'credit',
            colId: 'credit',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.CreditUnit'),
            field: 'currency',
            colId: 'currency',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.credit_accountPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.creditDateUnit'),
            field: 'termUnit',
            colId: 'termUnit',
            width: 80,
            minWidth: 80,
            cellRenderer: (params) => {
              const termMap = this.termUnitList.find(item => item.value === params.value)
              if (termMap) {
                return termMap.name
              }
              return ''
            }
          }
        ],
        gridOptions: {
          // 单击显示编辑
          singleClickEdit: true,
          onSortChanged: this.rowDataChanged
        },
        rowData: []
      },
      form: {
        uuid: '',
        creditDateType: -1,
        creditDateLimited: 0,
        paymentPeriodDateLimited: 0,
        paymentPeriodTermUnit: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        blacklist: false,
        usedAmount: 0,
        amountExceeded: false,
        dateExceeded: false,
        remarks: 'ETD',
        receivableDeposit: false,
        depositCurrency: 'RMB',
        depositAmount: 0,
        depositDate: '',
        depositType: 2, // 默认转账
        creditRemarks: '',
        companyUuid: '',
        tempNumberAllocation: 0,
        // REQ-0022 新增合作伙伴 ETD 天数默认 100
        etdDays: 100
      },
      checkedList: [],
      creditDateTypeObj: {
        val1: -1,
        val2: 0
      },
      contractCreditDateTypeObj: {
        val1: -1,
        val2: 0
      },
      gridOptions: {
        suppressCellSelection: false,
        suppressContextMenu: false // 右键列表弹出菜单
      },
      columnDefs: [
        {
          headerName: this.$t('Information.ApplicableOrderRulescombinedName'),
          width: 250,
          field: 'ruleGroupName'
        }
      ],
      rowData: [],
      currencySet: new Set(),
      contractList: [
        {
          ruleName: RULE_ALL_ORDERS.chineseName,
          uuid: RULE_ALL_ORDERS.code
        }
      ],
      noCustomerContractList: [],
      currentContract: {
        ruleName: RULE_ALL_ORDERS.chineseName,
        uuid: RULE_ALL_ORDERS.code
      },
      termUnitList: [
        { value: 0, name: this.$t('Partners.day') },
        { value: 1, name: this.$t('Partners.week') },
        { value: 2, name: this.$t('Partners.month') }
      ],
      currentOnlyCreditInfo: {
        uuid: '',
        creditDateType: -1,
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        blacklist: false,
        usedAmount: 0,
        amountExceeded: false,
        dateExceeded: false,
        remarks: 'ETD',
        receivableDeposit: false,
        depositCurrency: 'RMB',
        depositAmount: 0,
        depositDate: '',
        depositType: 2, // 默认转账
        creditRemarks: '',
        companyUuid: '',
        // REQ-0022 新增合作伙伴 ETD 天数默认 100
        etdDays: 100
      }, // 仅 信控信息
      currentOnlyCreditInfoBkg: {}, // 非客户协议合同规则选择时，当前信控都取该值
      isZy: false, // 是否中邮
      normalRuleContactExist: false // 是否存在指定规则合同
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    settlementType() {
      return this.currentOnlyCreditInfo.creditDateLimited === 0 && this.creditDateTypeObj.val1 !== 'n'
    },
    contractSettlementType() {
      return this.contractCreditInfo.creditDateLimited === 0 && this.contractCreditDateTypeObj.val1 !== 'n'
    },
    creditDisable() {
      return hasMenu('ContractManagement') && this.isvalidContract
    },
    showActualCreditGracePeriodDays() {
      return this.actualCreditGracePeriodDays > 0
    }
  },
  async created() {
    this.initialForm = this.form
    this.initialContractCreditInfo = this.contractCreditInfo
    await cache.load(cacheName.CONFIG)
    this.config = cache.config
    this.creditUseMultipleCurrency = Number(this.config.get('creditUseMultipleCurrency')) === 1
    this.actualCreditGracePeriodDays = Number(this.config.get('actualCreditGracePeriodDays'))
    this.isZy = String(cache.config.get('ToExoSystem')) === 'zy'
    this.initCurrencySet()
    // 监听转为票结客户的事件（由合同约号页签触发）
    this.$root.$on('convertToTicketSettlement', this.handleConvertToTicketSettlement)
  },
  beforeDestroy() {
    this.$root.$off('convertToTicketSettlement', this.handleConvertToTicketSettlement)
  },
  methods: {
    async onShow(row, isRefresh) {
      this.getListFunc(row)
      if (isRefresh) {
        this.tempCreditInfo.rowData = []
        this.row = row
        if (row.uuid) {
          this.getForm()
          await queryCustomerCompanyIsOver({ customerId: row.cmpIdx }).then(resp => {
            this.successHandler(resp.data)
          })
        } else {
          this.form = this.row.creditInfo
          Object.assign(this.form, this.initialForm)
          Object.assign(this.contractCreditInfo, this.initialContractCreditInfo)
          this.creditDateTypeObj.val1 = -1
          this.creditDateTypeObj.val2 = 0
          this.contractCreditDateTypeObj.val1 = -1
          this.contractCreditDateTypeObj.val2 = 0
          getDefaultCreditInfo({ branchId: this.branchId }).then(res => {
            if (res.ok) {
              const data = res.data
              if (data && data.uuid) {
                this.form.remarks = data.remarks
                this.form.creditDateType = data.creditDateType
                this.form.creditDateLimited = data.creditDateLimited
                this.form.credit = data.credit
                this.form.termUnit = data.termUnit
                this.form.currency = data.currency
                if (this.form.creditDateType === 0) {
                  this.form.creditDateType = -1
                }
                if (this.form.creditDateType === -1 || this.form.creditDateType === -2 || this.form.creditDateType === -3 || this.form.creditDateType === -4) {
                  this.creditDateTypeObj.val1 = this.form.creditDateType
                } else {
                  this.creditDateTypeObj.val1 = 'n'
                  this.creditDateTypeObj.val2 = this.form.creditDateType
                }
              }
            }
          })
          this.currentOnlyCreditInfo = this.form
        }
        const checkedList = []
        checkedList.push(this.form.receivableDeposit)
        this.checkedList = checkedList
      }
    },
    // 获取适用客户列表
    async getListFunc(row) {
      const data = {
        cmpIdx: row.cmpIdx
      }
      const res = await availableReleaseDocRuleGroupList(data)
      if (res.ok) {
        this.rowData = res.data || []
      }
    },
    async getForm() {
      this.form = this.row.creditInfo // 非信控相关的信息，依旧从form中取
      if (!this.form.uuid) {
        Object.assign(this.form, this.initialForm)
        Object.assign(this.contractCreditInfo, this.initialContractCreditInfo)
      }
      const data = {
        companyUuid: this.row.uuid,
        creditInfo: true
      }
      const res = await loadCompanyRelated(data)
      if (res && res.data && res.data.creditInfo && res.data.creditInfo.length > 0) {
        this.form = res.data.creditInfo[0]
        if (res.data.tempCreditInfo) {
          this.tempCreditInfo.rowData = res.data.tempCreditInfo
        }
        if (res.data.contractCreditInfo) {
          this.contractCreditInfo = res.data.contractCreditInfo
        }
      } else {
        Object.assign(this.form, this.initialForm)
        Object.assign(this.contractCreditInfo, this.initialContractCreditInfo)
      }
      // 初始化【合同规则】信息
      this.contractList = res.data.contractList
      this.currentContract = this.contractList[0]
      this.normalRuleContactExist = res.data.normalRuleContactExist
      if (this.normalRuleContactExist) {
        this.currentOnlyCreditInfo = this.currentContract
        // CARGO-43264 有指定规则合同时，【合同信控】显示快照
        this.contractCreditInfo = lodash.cloneDeep(this.currentOnlyCreditInfo)
        this.contractCreditInfo.credit = this.contractCreditInfo.snapCredit
        this.contractCreditInfo.creditDateLimited = this.contractCreditInfo.snapCreditDateLimited
        this.tempCreditInfo.rowData = this.currentContract.tempCreditInfoList
      } else {
        this.currentOnlyCreditInfo = this.form
        // 存起来，切换合同时进行赋值
        // 全部规则的客户协议合同 标志
        this.contractList[0].allRuleCustomerFlag = true
        this.contractList[0].currentOnlyCreditInfo = this.currentOnlyCreditInfo
        this.currentOnlyCreditInfoBkg = this.currentOnlyCreditInfo
        this.contractList[0].tempCreditInfo = this.tempCreditInfo.rowData
        this.contractList[0].contractCreditInfo = this.contractCreditInfo
      }
      this.changePaymentTerm(this.currentContract)
      // 非客户协议合同
      if (res.data.noCustomerContractList && res.data.noCustomerContractList.length > 0) {
        this.noCustomerContractList = res.data.noCustomerContractList
        if (this.contractList) {
          this.contractList.push(...res.data.noCustomerContractList)
        }
      }
      if (this.contractList && this.contractList.length > 0) {
        this.contractList.forEach(contract => {
          // 合同 与 合作伙伴 保持一致
          contract.remarks = contract.dateType
        })
      }
      this.refreshCreditDateTypeObj()
    },
    refreshCreditDateTypeObj() {
      if (this.currentOnlyCreditInfo.creditDateType === 0) {
        this.currentOnlyCreditInfo.creditDateType = -1
      }
      if (this.currentOnlyCreditInfo.creditDateType === -1 || this.currentOnlyCreditInfo.creditDateType === -2 || this.currentOnlyCreditInfo.creditDateType === -3 || this.currentOnlyCreditInfo.creditDateType === -4) {
        this.creditDateTypeObj.val1 = this.currentOnlyCreditInfo.creditDateType
      } else {
        this.creditDateTypeObj.val1 = 'n'
        this.creditDateTypeObj.val2 = this.currentOnlyCreditInfo.creditDateType
      }
      if (this.contractCreditInfo.creditDateType === 0) {
        this.contractCreditInfo.creditDateType = -1
      }
      if (this.contractCreditInfo.creditDateType === -1 || this.contractCreditInfo.creditDateType === -2 || this.contractCreditInfo.creditDateType === -3 || this.contractCreditInfo.creditDateType === -4) {
        this.contractCreditDateTypeObj.val1 = this.contractCreditInfo.creditDateType
      } else {
        this.contractCreditDateTypeObj.val1 = 'n'
        this.contractCreditDateTypeObj.val2 = this.contractCreditInfo.creditDateType
      }
    },
    getSubmitData() {
      const form = this.form
      const val = this.creditDateTypeObj.val1 !== 'n' ? this.creditDateTypeObj.val1 : this.creditDateTypeObj.val2
      form.creditDateType = val || 0
      return { creditInfo: form }
    },
    successHandler(length) {
      if (length > 0) {
        this.isvalidContract = true
        if (hasMenu('ContractManagement')) {
          this.tipVisible = true
        }
      } else {
        this.tipVisible = false
        this.isvalidContract = false
      }
    },
    handleBlacklistChange(checked) {
      const etdDays = checked ? -1 : 100
      if (this.form) this.form.etdDays = etdDays
      if (this.currentOnlyCreditInfo) this.currentOnlyCreditInfo.etdDays = etdDays
      if (this.currentOnlyCreditInfoBkg && typeof this.currentOnlyCreditInfoBkg === 'object') {
        this.currentOnlyCreditInfoBkg.etdDays = etdDays
      }
    },
    initCurrencySet() {
      if (this.creditUseMultipleCurrency) {
        const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
        const priorityCurrencies = results.filter(currency =>
          currency.code === 'RMB' || currency.code === 'USD' || currency.code === 'EUR')
        const otherCurrencies = results.filter(currency =>
          currency.code !== 'RMB' && currency.code !== 'USD' && currency.code !== 'EUR')
        this.currencySet = new Set([...priorityCurrencies, ...otherCurrencies])
      } else {
        this.currencySet = new Set([{ code: 'RMB' }, { code: 'USD' }])
      }
    },
    async currencyChanged() {
      if (!this.creditUseMultipleCurrency) {
        return
      }
      const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      let invalid = false
      let localCurrency = ''
      const invalidCurrencyList = []
      const currencyList = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
      const useLocalCurrency = RateUtil.useLocalCurrency()
      if (useLocalCurrency) {
        for (const office of officeList) {
          localCurrency = office.currency
          if (localCurrency) {
            const needCheck = office.currency !== this.form.currency
            const rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.form.currency, new Date(), 0, 0, false, true)
            if (needCheck && (isNaN(rate) || rate === 0)) {
              let hasRate = false
              for (const currency of currencyList) {
                const code = currency.code
                const localRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, code, new Date(), 0, 0, false, true)
                const toLocalRate = await RateUtil.getForeignExchangeRateSafely(code, this.form.currency, new Date(), 0, 0, false, true)
                if (!isNaN(localRate) && localRate !== 0 && !isNaN(toLocalRate) && toLocalRate !== 0) {
                  hasRate = true
                  break
                }
              }
              if (!hasRate) {
                invalid = true
                if (!invalidCurrencyList.includes(localCurrency)) {
                  invalidCurrencyList.push(localCurrency)
                }
              }
            }
          }
        }
      } else {
        const rate = await RateUtil.getForeignExchangeRateSafely('RMB', this.form.currency, new Date(), 0, 0, false, true)
        invalid = (isNaN(rate) || rate === 0)
        if (invalid) {
          invalidCurrencyList.push('RMB')
        }
      }
      if (invalid) {
        this.$message.warning(this.$t('Information.unSupportContractCurrency', [this.form.currency, invalidCurrencyList.join(',')]))
        this.form.currency = this.lastCurrency
      } else {
        this.lastCurrency = this.form.currency
      }
    },
    contractChange(contractUuid) {
      this.currentContract = this.contractList.filter(item => item.uuid === contractUuid)[0]
      // 全部规则的客户协议合同
      if (this.currentContract.allRuleCustomerFlag) {
        this.currentOnlyCreditInfo = this.currentOnlyCreditInfoBkg
        this.tempCreditInfo.rowData = this.contractList[0].tempCreditInfo
        this.contractCreditInfo = this.contractList[0].contractCreditInfo
      } else {
        this.currentOnlyCreditInfo = this.currentContract
        // CARGO-43264 有指定规则合同时，【合同信控】显示快照
        this.contractCreditInfo = lodash.cloneDeep(this.currentContract)
        this.contractCreditInfo.credit = this.contractCreditInfo.snapCredit
        this.contractCreditInfo.creditDateLimited = this.contractCreditInfo.snapCreditDateLimited
        this.tempCreditInfo.rowData = this.currentContract.tempCreditInfoList
      }
      this.changePaymentTerm(this.currentContract)
      this.refreshCreditDateTypeObj()
    },
    changeReceivableDeposit(checkedList) {
      if (checkedList.length > 1) {
        checkedList.shift() // 移除第一个选中的选项
      }
      this.checkedList = checkedList
      this.form.receivableDeposit = checkedList.length === 1 ? checkedList[0] : false
    },
    changePaymentTerm(currentContract) {
      if (this.showActualCreditGracePeriodDays) {
        this.contractCreditInfo.creditDateLimited = currentContract.creditDateLimited
        this.contractCreditInfo.termUnit = currentContract.termUnit
        this.contractCreditInfo.paymentTerm = currentContract.paymentTerm
        this.contractCreditInfo.paymentTermUnit = currentContract.paymentTermUnit
      }
    },
    // 事件处理包装器
    handleConvertToTicketSettlement() {
      this.convertToTicketSettlement()
    },
    // 转换为票结客户（由合同约号页签调用）
    convertToTicketSettlement() {
      // 使用 $set 确保响应式更新 — 账期设为0
      this.$set(this.form, 'creditDateLimited', 0)
      this.$set(this.form, 'creditDateType', -1)
      // currentOnlyCreditInfo 是 UI 实际绑定的对象
      if (this.currentOnlyCreditInfo) {
        this.$set(this.currentOnlyCreditInfo, 'creditDateLimited', 0)
        this.$set(this.currentOnlyCreditInfo, 'creditDateType', -1)
      }
      // 结算类型下拉框
      this.$set(this.creditDateTypeObj, 'val1', -1)
      this.$set(this.creditDateTypeObj, 'val2', 0)
      // 刷新结算类型显示
      this.refreshCreditDateTypeObj()
      // $nextTick + $forceUpdate 确保视图刷新
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.credit-info-form {
  &.section {
    padding: 20px;
  }
  .box {
    position: relative;
    padding-top: 10px;
    .box-label {
      position: absolute;
      left: 10px;
      top: 0;
      padding: 0 5px;
      border-radius: 3px;
      font-size: 13px;
      line-height: 20px;
      background: #f5f7fa;
      color: #404144;
    }
    .box-content {
      width: 100%;
      border: 1px solid #ababab;
      border-radius: 5px;
      padding: 10px 0;
    }
  }
  .form-item-350 ::v-deep {
    .el-form-item__content {
      width: 350px;
      .el-date-editor.el-input {
        width: 350px;
      }
    }
  }
  .margin-Right50 {
    margin-right: 50px;
  }
}
</style>
